import { useEffect } from "react";

// Helper hook to setup a infinite callback using requestAnimationFrame
// This will run roughly 60 times per second, good for animations and dom updates
export default (callback: () => void, deps: unknown[] = []) => useEffect(() => {
    let rafIndex = 0;

    const wrapperCallback = () => {
        callback();
        rafIndex = window.requestAnimationFrame(wrapperCallback);
    };

    rafIndex = window.requestAnimationFrame(wrapperCallback);

    return () => {
        window.cancelAnimationFrame(rafIndex);
    };
}, deps);
